import { useTranslation } from 'react-i18next';
import { Box, Typography } from 'bonfire-kindling';
import { useVendor } from 'helpers/vendor';
import theme from 'constants/theme';
import { Keywords } from 'components';

const KeywordSettings = ({ onSubmit, isMutating }) => {
  const { t } = useTranslation();
  const { data: vendor } = useVendor();

  return (
    <>
      <Box mb={4}>
        <Typography variant="h1" component="h2" style={{ marginBottom: theme.spacing(2) }}>
          {t('settings.keywords.title')}
        </Typography>
        <Typography variant="body2" component="h3">
          {t('settings.keywords.add_instructions')}
        </Typography>
      </Box>
      <Keywords
        keywords={vendor.keywords}
        onSubmit={onSubmit}
        onRemoveKeyword={onSubmit}
        isMutating={isMutating}
      />
    </>
  );
};

export default KeywordSettings;
